<div matDialogTitle class="notification-details__header">
  <h1 class="notification-details__header__title">{{ details?.notificationTypeName }}</h1>
  <button mat-icon-button matDialogClose class="notification-details__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="notification-details__content">
  <div class="notification-details-content">
    <div class="notification-details__column notification-details-map">
      <fm-google-maps-light [coordinates]="details?.coordinates"></fm-google-maps-light>
    </div>
    <div class="notification-details__column">
      <p class="notification-details-title" i18n="@@S_DRIVER_NAME">Driver Name</p>
      <p class="notification-details-info">{{ details?.driverName }}</p>

      <p class="notification-details-title" i18n="@@S_VEHICLE_NAME">Vehicle Name</p>
      <p class="notification-details-info">{{ details?.vehicleName }}</p>

      <p class="notification-details-title" i18n="@@S_ALERT_TYPE">Alert Type</p>
      <p class="notification-details-info">{{ details?.notificationType }}</p>

      <p class="notification-details-title" i18n="@@S_ALERT_TRIGGER">Alert Trigger</p>
      <p class="notification-details-info">{{ details?.triggerType }}</p>

      <p class="notification-details-title" i18n="@@S_LOCATION">Location</p>
      <p class="notification-details-info">{{ details?.location }}</p>
    </div>
    <div class="notification-details__column">
      <p class="notification-details-title" i18n="@@S_DRIVER_EMAIL">Driver Email</p>
      <p class="notification-details-info">{{ details?.driverEmail }}</p>

      <p class="notification-details-title" i18n="@@S_VEHICLE_NUMBER">Vehicle Number</p>
      <p class="notification-details-info">{{ details?.vehicleNumber }}</p>

      <p class="notification-details-title" i18n="@@S_THRESHOLD">Threshold</p>
      <p class="notification-details-info">{{ details?.threshold }}</p>

      <p class="notification-details-title" i18n="@@S_TRIGGER_TIME">Trigger Time</p>
      <p class="notification-details-info">{{ details?.dateTime }}</p>
    </div>
  </div>
</div>

<div matDialogActions class="notification-details__actions">
  <button
    mat-flat-button
    color="accent"
    id="btn-closeAlertDetail"
    i18n="@@S_CLOSE"
    class="notification-details__actions__buttons__save btn-uppercase vzc-small"
    (click)="onCloseClick()"
  >
    CLOSE
  </button>
</div>
